<template>
    <ModalEdition :isEdition="params.id != null" :modalId="'modalEditFournisseur'" ref="modalFournisseurRef"
        @save="saveFournisseur">
        <div class="fournisseur">
            <div class="form">
                <div class="form-group">
                    <label for="fournisseur_libelle">Libellé</label>
                    <input type="text" class="form-control" id="fournisseur_libelle" v-model="fournisseur.libelle" />
                </div>

            </div>
        </div>
    </ModalEdition>
</template>

<script>
import Axios from '@/services/axios.service';
import ModalEdition from '../../../../components/ModalEdition.vue';

export default {
    name: 'fournisseurEdit',
    components: {
        ModalEdition
    },
    props: {
        params: {
            type: Object,
            required: false,
            default: () => ({}),
        },

    },
    data() {
        return {
            fournisseur: {},
            errors: [],
        }
    },
    methods: {
        getFournisseur(id) {
            Axios.get('/fournisseur/' + id).then(res => {
                this.fournisseur = res.data;
            })
        },
        saveFournisseur() {
            this.errors = []

            if (this.fournisseur.libelle == null) {
                this.errors.push('Le libelle est requis')
            }
        
            Axios.post('/fournisseur', this.fournisseur)
                .then(() => {
                    this.$refs.modalFournisseurRef.closeModal();
                    this.$emit('saved');
                }).catch(err => {
                    this.errors.push({ message: 'Erreur lors de la sauvegarde du fournisseur:', err });
                });
        }
    },
    watch: {
        params: {
            handler(params) {
                if (params.id != null) {
                    this.getFournisseur(params.id);
                } else {
                    this.fournisseur = {};
                }
            },
            deep: true,
        },
    },
}
</script>

<style></style>
